module.exports = __webpack_public_path__ + "static/media/soul-bottom-cloud-left.c205043f.svg";